import { z } from "zod";

export const DocumentationSettings = z.object({
  // Basic
  designSystemVersionId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),

  // Configuration
  isTabbedLayoutEnabled: z.boolean(),
  storybookEmbedErrorMessage: z.string().optional(),
  renderCodePackageJson: z.string().optional(),
  selectedBrandPersistentId: z.string().optional(),
  serveDefaultVersionOnly: z.boolean(),
  isPublic: z.boolean(),
});

export type DocumentationSettings = z.infer<typeof DocumentationSettings>;
